export function toLocalTimestamp(date){
  const tzDifference = date.getTimezoneOffset();
  return date.getTime() + tzDifference * 60 * 1000;
}

export function getLocalTimestamp(){
  return toLocalTimestamp(new Date());
}